<template>
	<!-- SET ROUTING TYPE -->
	<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" v-if="wasMounted">
		<span class="cursor-pointer flex items-center">
			<span class="hidden sm:block ml-2 text-white">{{ $t("RoutingType.SelectedRouter") }} &nbsp;&nbsp;</span>
			<vs-chip :color="colorChip(selectedRoutingType)" class="mr-4">
				{{ selectedRoutingType }}
			</vs-chip>
		</span>
		<vs-dropdown-menu
			:style="positionLeft ? positionLeft : ''"
			class="cart-dropdown dropdown-custom-left vx-navbar-dropdown"
		>
			<div class="notification-top text-center p-5 bg-success text-white">
				<h4 class="text-white">
					{{ $t("RoutingType.AvailableRoutingTypes") }}
				</h4>
				<span class="vs-table-text font-light">{{ $t("RoutingType.SelectRoutingType") }}</span>
			</div>
			<component
				:is="scrollbarTag"
				ref="mainSidebarPs"
				class="scroll-area--nofications-dropdown p-0 mb-10"
				:settings="settings"
				:key="$vs.rtl"
			>
				<ul class="bordered-items">
					<li
						v-for="(routingType, index) in routingTypes"
						:key="index"
						class="flex justify-between px-4 py-4 notification cursor-pointer"
						@click="handleChangeRoutingType(routingType.name)"
					>
						<div class="flex items-start">
							<feather-icon
								v-if="validateSelectedType(routingType.name)"
								title="Revisar"
								icon="CheckCircleIcon"
								:svgClasses="[`text-success`, 'stroke-current mr-1 h-6 w-6']"
							></feather-icon>
							<div class="mx-2">
								<span
									class="font-medium block"
									:class="[
										{
											'text-success': validateSelectedType(routingType.name),
										},
									]"
								>
									{{ routingType.name }}</span
								>
								<small>{{ routingType.description }}</small>
							</div>
						</div>
					</li>
				</ul>
			</component>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";
import moduleCompany from "@/store/company/moduleCompany.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import * as constants from "@/constants";

export default {
	props: {
		positionLeft: {
			type: String,
			default: "",
		},
	},
	components: {
		VuePerfectScrollbar,
	},
	data() {
		return {
			checkbox_remember_me: false,
			routingTypesPopupActive: false,
			multipleSave: false,
			company_id: "",
			notifications: [],
			notificationsCopy: [],
			routingTypes: [],
			count: 0,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			pathRefNofication: "",
			map: new Map(),
			wasMounted: false,
		};
	},
	computed: {
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		selectedRoutingType() {
			const routingType = this.$store.dispatch("moduleRoutingType/getRouting");
			routingType.then((res) => {
				if (res) this.$store.commit("SET_ROUTING_TYPE", res.type);
			});
			return this.$store.state.routingType;
		},
		selectedTypeVehicle() {
			return this.$store.state.moduleRoutingType.typeVehicle;
		},
		colorChip() {
			return function (params) {
				let color;
				switch (params) {
					case constants.GMPRO:
						color = "#3D79B8";
						break;
					case constants.OPENROUTE:
						color = "#b5152b";
						break;
					case constants.TOUR_PLANNING:
						color = "#30b59a";
						break;
					default:
						color = "#F3F3F3";
						break;
				}
				return color;
			};
		},
	},
	methods: {
		validateSelectedType(val) {
			return this.selectedRoutingType === val;
		},
		async handleChangeRoutingType(type) {
			this.$store.commit("SET_ROUTING_TYPE", type);
			await this.$store.dispatch("moduleRoutingType/saveRouting", type);
			const vehicleTypesGMPRO = ["truck", "scooter", "bus", "bicycle"];
			const vehicleTypesOPENROUTE = ["truck", "scooter", "bus", "unknown"];
			if (
				(type === "GMPRO" && vehicleTypesGMPRO.includes(this.selectedTypeVehicle)) ||
				(type === "OPENROUTE" && vehicleTypesOPENROUTE.includes(this.selectedTypeVehicle)) ||
				(type === "TOUR_PLANNING" && this.selectedTypeVehicle === "unknown")
			) {
				this.$store.commit("moduleRoutingType/SET_TYPE_VEHICLE", "car");
				await this.$store.dispatch("moduleRoutingType/saveTypeVehicle", "car");
			}
			this.$modal.hide("routingModal");
		},
		async getCompanyById(id) {
			const dataPage = {
				ids: [id],
				order_by: ["id"],
				sort: "asc",
			};
			try {
				const res = await this.$store.dispatch("moduleCompany/fetchCompanyFilter", dataPage);
				if (!res || !res.records || res.records.length === 0) {
					return;
				}
				const company = res.records[0];
				const routingType = await this.$store.dispatch("moduleRoutingType/getRouting");
				if (routingType) {
					this.checkbox_remember_me = routingType.availableRouters;
				}
				this.$store.commit("moduleCompanyConfigCrud/TOGGLE_ROUTING_TYPE_DROP_DOWN", true);
				if (company.optimizers && company.optimizers.length > 0) {
					await this._handleOptimizers(company.optimizers, routingType);
					this.wasMounted = true;
				}
			} catch (err) {
				console.error(err);
			}
		},
		_createRoutingTypeObject(name) {
			switch (name) {
				case "OPENROUTE":
					return {name, description: this.$t("RoutingType.OpenRoute")};
				case "GMPRO":
					return {name, description: this.$t("RoutingType.Fleetrouting")};
				case "TOUR_PLANNING":
					return {name, description: this.$t("RoutingType.TourPlanning")};
				default:
					return null;
			}
		},
		async _handleOptimizers(optimizers, routingType) {
			this.$store.commit("moduleOptimization/SET_COMPANY_OPTIMIZERS", optimizers);
			if (optimizers.length === 1) {
				this.handleChangeRoutingType(optimizers[0]);
			}
			this.routingTypes = optimizers.map((optimizer) => this._createRoutingTypeObject(optimizer)).filter(Boolean);
			if (routingType && !this.routingTypes.some((rt) => rt.name === routingType.type)) {
				this.$store.commit("SET_ROUTING_TYPE", optimizers[0]);
				await this.$store.dispatch("moduleRoutingType/saveRouting", optimizers[0]);
			}
		},
	},
	created() {
		// Registra el modulo
		if (!moduleCompanyConfigCrud.isRegistered) {
			this.$store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
			moduleCompanyConfigCrud.isRegistered = true;
		}
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));
		this.getCompanyById(userInfo.serviroutes_company_id);
	},
};
</script>
